document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.dm-mobile-menu').forEach(menu => {
    menu.addEventListener('keydown', event => {
      if(event.key === 'Escape') {menu.open = false;menu.querySelector('summary').focus();}
    });
    menu.querySelectorAll('a').forEach(a => a.addEventListener('click',()=>{menu.open=false;}));
    document.addEventListener('click',event=>{if(!menu.contains(event.target))menu.open=false;});
  });
  document.addEventListener('click', event => {
    const a = event.target.closest('[data-dm-channel], [data-dm-document]');
    if(!a) return;
    const detail = a.dataset.dmChannel ? {event:'outbound_shop_click', channel:a.dataset.dmChannel}
      : {event:'document_download', product:a.dataset.dmDocument};
    // This event is local only. No analytics vendor or tracking script is added.
    document.dispatchEvent(new CustomEvent('dealmart:interaction',{detail}));
  });
});